import { BaseAPIService } from './BaseAPI.service';
import { Injectable } from '@angular/core';
import { getBindings } from '@onviobr/services/session';
import { HttpClient } from '@angular/common/http';
import { IActivityCategorySearch, IPagedItemsDto, IActivityCategoryDto } from '@shared/models';
import { from, Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ActivityCategoryService extends BaseAPIService {

	constructor(private httpClient: HttpClient) {
		super();
	}

	/** Gets lists of activity categories for the specified company */
	postSearch(params: IActivityCategorySearch): Observable<IPagedItemsDto<IActivityCategoryDto>> {
		return from(getBindings()).pipe(
			concatMap(sessionData => {
				const companyId = sessionData.ApplicationConfiguration.CompanyId;
				return this.httpClient.post(`/api/core/v1/companies/${companyId}/activity-categories/search`, params.postData);
			})
		);
	}
}
